import React, { useState } from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Components //
import TitleSectionRich from "../../molecules/title-section-rich/title-section-rich";
import InfoCard from "../../molecules/info-card/infoCard";

// Styles //
import "./communitiesBenefits.scss";

const CommunitiesBenefits = (props: ReferenciaContenido) => {
    const [activedCard, setActivedCard] = useState(-1);

    const {
        tituloGeneral,
        descripcion,
        referenciaPlantillaContenido: refPlantilla,
    } = props;
    
    return (
        <div className="o-communities-benefits">
            <div className="container">
                <TitleSectionRich
                    title={tituloGeneral}
                    description={descripcion}
                    subtitle={true}
                />
                <div className="o-communities-benefits__container">
                    {refPlantilla.map((item, index) => (
                        <InfoCard
                            key={index}
                            onClick={() => setActivedCard(index)}
                            active={activedCard}
                            index={index}
                            title={item.tituloBanner}
                            description={
                                item.descripcion.json.content[0].content[0]
                                    .value
                            }
                            imageUrl={item.imagenPrincipal[0].file.url}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CommunitiesBenefits;
